import { of as observableOf, Observable } from 'rxjs';

import { map, tap } from 'rxjs/operators';
import { OccupationCategory } from '../models/occupation-category.model';
import { UrlConfigContainer } from '../../core/url-config';
import { AjaxDataServiceService } from '../../core/ajax-data-service.service';
import { Injectable } from '@angular/core';
import { UrlConfigService } from '@hrra/core';

import { LookupInitData } from '@admin/shared/models/lookup-init-data';
import { Utils } from '@admin/shared/utils';
import { Specialization } from '../models/specializations.model';

@Injectable()
export class LookupService {
  private cachedLookupData: LookupInitData;

  // private cachedOccupationCategories: OccupationCategory[];
  // //TODO
  // private cachedLocalities;
  // private cachedLanguages;
  // private cachedEducationLevels;
  // private cachedDocumentTypes;

  //TODO load on demind selectively
  public loadAllLookups(): Observable<boolean> {
    return this.ajax
      .getData(this.urlService.urlConfig.api.data.lookup.multi.get, {}, LookupInitData)
      .pipe(
        tap((d: LookupInitData) => {
          d.specializations?.forEach((spec: any) => {
            if (
              spec.head?.specializationId !== null &&
              spec.head?.specializationId !== undefined
            ) {
              spec.headId = spec.head.id;
            }

            if (spec.head?.specializationId == null) {
              spec.headId = spec.specializationId;
            }
          });

          d.industries?.forEach((industry: any) => {
            if (
              industry.head?.industryId !== null &&
              industry.head?.industryId !== undefined
            ) {
              industry.headId = industry.head.id;
            }

            if (industry.head?.industryId == null) {
              industry.headId = industry.industryId;
            }
          });
        }),

        map((d) => {
          this.cachedLookupData = d;
          return true;
        })
      );
    //return Observable.of(true);//TODO temp
  }

  public getCachedLookupData(): LookupInitData {
    return this.cachedLookupData;
  }

  public getLookupData(useCache: boolean = true): Observable<LookupInitData> {
    if (useCache && this.cachedLookupData) {
      return observableOf(this.cachedLookupData);
    }

    return this.ajax
      .getData(this.urlService.urlConfig.api.data.lookup.multi.get, {}, LookupInitData)
      .pipe(
        tap((d: LookupInitData) => {
          d.specializations?.forEach((spec: any) => {
            if (
              spec.head?.specializationId !== null &&
              spec.head?.specializationId !== undefined
            ) {
              spec.headId = spec.head.id;
            }
          });
          this.cachedLookupData = d;
        })
      );
  }

  public getCachedOccupationCategories() {
    return this.cachedLookupData.occupationCategories;
  }

  public getHeadCategories(
    allCategories: OccupationCategory[]
  ): OccupationCategory[] {
    let headCategories = [];
    allCategories.forEach((c) => {
      if (c.isHeadOld()) {
        headCategories.push(c);
      }
    });

    return headCategories;
  }

  public getChildCategories(
    allCategories: OccupationCategory[]
  ): OccupationCategory[] {
    let childCategories = [];
    allCategories.forEach((c) => {
      if (!c.isHeadOld()) {
        childCategories.push(c);
      }
    });

    return childCategories;
  }

  public getChildSpecializations(
    allSpecializations: Specialization[]
  ): Specialization[] {
    let childSpecializations = [];
    allSpecializations.forEach((c) => {
      if (!c.isHead) {
        childSpecializations.push(c);
      }
    });

    return childSpecializations;
  }

  public groupOccupationCategories(allCategories: OccupationCategory[]): {
    headCategory: OccupationCategory;
    childCategories: OccupationCategory[];
  }[] {
    //let w = this.workExperience;

    let result: {
      headCategory: OccupationCategory;
      childCategories: OccupationCategory[];
    }[] = [];

    let headCategoriesMap = Utils.toMap(
      this.getHeadCategories(allCategories),
      (c) => c.occupationCategoryId
    );

    if (allCategories && allCategories.length && allCategories.length > 0) {
      let grouping = Utils.groupBy(allCategories, (c) => c.headId);

      for (let key in grouping) {
        result.push({
          headCategory: headCategoriesMap[key],
          childCategories: grouping[key],
        });
      }
    }

    return result;
  }

  public getOccupationCategories(
    useCache: boolean = true
  ): Observable<OccupationCategory[]> {
    if (
      useCache &&
      this.cachedLookupData != null &&
      this.cachedLookupData.occupationCategories != null
    ) {
      return observableOf(this.cachedLookupData.occupationCategories);
    }
    return this.ajax
      .getDataPaging(
        this.urlService.urlConfig.api.data.lookup.occupationCategory.list,
        {},
        OccupationCategory
      )
      .pipe(
        tap((d) => (this.cachedLookupData.occupationCategories = d.items)),
        map((d) => d.items)
      );
  }

  constructor(
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}
}
